import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortable } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { finalize } from 'rxjs/operators';
import { BasicService } from 'src/app/shared/services/basic.service';

import { AddAccountService } from '../add-account.service';
import { VonageSubAccountNumber } from './models';
import { WhatsappAccountVonageService } from './whatsapp-account-vonage.service';

@Component({
  selector: 'app-whatsapp-account-vonage',
  templateUrl: './whatsapp-account-vonage.component.html',
  styleUrls: ['./whatsapp-account-vonage.component.scss'],
})
export class WhatsappAccountVonageComponent implements OnInit {
  buttonDisabled = true;

  dataSource: MatTableDataSource<VonageSubAccountNumber> = new MatTableDataSource([]);
  displayedColumns: string[] = ['radio', 'phoneNumber', 'businessName', 'applicationId'];

  selectedNumber: VonageSubAccountNumber;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private addAccountService: AddAccountService,
    private whatsappAccountVonageNewService: WhatsappAccountVonageService,
    private basicService: BasicService,
    @Inject('$state') private $state: any,
    @Inject('TopToolbarFactory') private topToolbarService: any
  ) {
    this.topToolbarService.setTitleTranslation('add-account/vonage/connect-button', null);
  }

  ngOnInit(): void {
    this.basicService.showSpinner();
    this.whatsappAccountVonageNewService
      .getWhatsAppVonageAccountNumbers()
      .pipe(finalize(() => this.basicService.hideSpinner()))
      .subscribe((numbers: VonageSubAccountNumber[]) => {
        this.dataSource = new MatTableDataSource(numbers);

        this.dataSource.paginator = this.paginator;
        this.sort.sort({ id: 'applicationId', start: 'asc' } as MatSortable);
        this.dataSource.sort = this.sort;
      });
  }

  goBack() {
    this.$state.go('auth.alcmeon.fuse.parameters.accounts');
  }

  selectRow(row: VonageSubAccountNumber) {
    if (!row.applicationId) {
      this.selectedNumber = row;
    }
  }

  connect() {
    this.basicService.showSpinner();
    const data = this.selectedNumber;
    delete data.applicationId;

    this.whatsappAccountVonageNewService
      .connectWhatsAppVonageNumber(data)
      .pipe(finalize(() => this.basicService.hideSpinner()))
      .subscribe((siteId: number) => {
        this.addAccountService.redirectToAccount(siteId);
      });
  }

  cancel() {
    this.selectedNumber = null;
  }
}
